module.exports = __webpack_public_path__ + "img/1024.304f073e.png";